'use strict';

/**
 * Util function to generalize responses from backend
 */
function restResponse() {

	var answer = {
		type : OPERATION_TYPE.SUCESSFULL,
		data : null,
		httpcode : null,
		errorMessage : '--'
	};

	return {

		handleSuccessfullResponse : function(httpResponse, data) {
			if (httpResponse) {
				answer.httpcode = httpResponse.status;
			}

			answer.type = OPERATION_TYPE.SUCESSFULL;
			answer.data = data;
		},

		handleErrorResponse : function(httpResponse, data) {
			answer.httpcode = httpResponse.status;
			answer.type = OPERATION_TYPE.ERROR;
			answer.errorMessage = data ? data.message : "";

			if (httpResponse.status === 0) {
				answer.type = MESSAGE_TYPE.DANGER;
			} else if (httpResponse.status === 400) {
				answer.type = MESSAGE_TYPE.WARNING;
			} else if (httpResponse.status === 500) {
				answer.type = MESSAGE_TYPE.DANGER;
			} else {
				answer.type = MESSAGE_TYPE.DANGER;
			}
		},

		isSuccessfull : function() {
			if (answer.type === OPERATION_TYPE.SUCESSFULL) {
				return true;
			} else {
				return false;
			}
		},

		getData : function() {
			return answer.data;
		},

		getHttpCode : function() {
			return answer.httpcode;
		},

		getErrorDetail : function() {
			return answer.errorMessage;
		}

	};
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

function isEmpty(obj) {

	if (angular.isUndefined(obj)) return true;
	
	
    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0)    return false;
    if (obj.length === 0)  return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
}

function cloneObject(obj){
	return JSON.parse(JSON.stringify(obj));
}

/**
 * Objeto para menejar la configuracion de los calendarios de tarifas y
 * funciones comunes y repetitivas para este tipo de calendarios
 */
function utilFeeCalendar() {

	/*
	 * Configuración por defecto para los calendarios que manejan tarifas
	 */
	var dayNames = [ 'Domingo/Festivo', 'Lunes', 'Martes', 'Miercoles',
			'Jueves', 'Viernes', 'Sabado' ];

	return {

		getFirstDay : function() {
			return 1;
		},

		getSlotDuration : function() {
			return '00:60:00'; // las canchas se reservan por una hora
		},

		getDefaultDate : function() {
			return 'Mon Dec 1 2014 1:01:00 GMT-0500 (COT)'; // no cambiar esta
			// feha, dado que se
			// hacen cálculos a
			// partir de este
			// valor
		},

		getDefaultDateForCalendar : function() {
			return moment('2014-12-01T00:00:00'); // no cambiar esta feha,
			// dado que se hacen
			// cálculos a partir de este
			// valor
		},

		getInitTime : function() {
			return '06:00'; // la primera reserva generalmente empieza a las 6
			// de la mañana
		},

		getEndTime : function() {
			return '24:00'; // la última reserva termina a media noche
		},

		getDayNamesShort : function() {
			return [ 'Dom/Fest', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab' ];
		},

		getDayNames : function() {
			return dayNames;
		},

		getDefaultView : function() {
			return 'agendaWeek';
		},

		getDayNameByNumber : function(pos) {
			return dayNames[pos];
		},

		getYearFromMoment : function(mome) {
			var d = parseInt(mome.format('d'));
			return d;
		},

		getMonthFromMoment : function(mome) {
			var d = parseInt(mome.format('d'));
			return d;
		},

		getDayFromMoment : function(mome) {
			var d = parseInt(mome.format('d'));
			return d;
		},

		getHourFromMoment : function(mom) {
			var h = parseInt(mom.format('h'));
			return h;
		},

		getHour24FromMoment : function(mom) {
			var h24 = parseInt(mom.format('H'));
			return h24;
		},

		getMeridiemFromMoment : function(mom) {
			var m = mom.format('a');
			return m;
		}

	};
}

var _isNotMobile = (function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
    return !check;
})();
